import { useEffect } from 'react';

/**
 * Durable "current workspace" context (REVIEW-CORRECT C3).
 *
 * `wsId` normally comes from the `/app/workspace/:wsId/...` route param. But
 * account-level pages (e.g. `/app/profile`) render the same `AppShell` without
 * a `:wsId` param, which previously produced empty nav links like
 * `/app/workspace//feed`. We persist the last active workspace in
 * localStorage and fall back to it so the shell + back-links always resolve.
 */
const KEY = 'patronez.lastWorkspace';

export function setLastWorkspace(id: string | undefined | null): void {
  try {
    if (id) localStorage.setItem(KEY, id);
  } catch {
    /* private mode */
  }
}

export function getLastWorkspace(): string {
  try {
    return localStorage.getItem(KEY) || '';
  } catch {
    return '';
  }
}

/**
 * Returns the effective workspace id: the route param when present (and
 * persists it), otherwise the last-used workspace from storage. Use this in
 * shared chrome (AppShell) and on non-workspace pages so navigation never
 * loses the workspace.
 */
export function useEffectiveWorkspaceId(paramWsId: string | undefined): string {
  useEffect(() => {
    if (paramWsId) setLastWorkspace(paramWsId);
  }, [paramWsId]);
  return paramWsId || getLastWorkspace();
}
